export default function (text, length) {
  if (typeof text !== 'string' || typeof length !== 'number') {
    throw new Error('truncateText: incorrect values')
  }

  let truncatedText = text.substring(0, length)

  if (text.length > truncatedText.length) {
    truncatedText = truncatedText.trim() + '...'
  }

  return truncatedText
}
